export const PAGE_OPTIONS = [
  { groupName: '文章', code: 'articles', name: '文章管理', path: '/articles' },
  { groupName: '文章', code: 'crawl', name: '文章收录', path: '/crawl' },
  { groupName: '文章', code: 'sites', name: '源站点管理', path: '/sites' },
  { groupName: '独立站运营', code: 'independent-site-products', name: '独立站商品采集', path: '/independent-site-products' },
  { groupName: '官网矩阵', code: 'website-matrix', name: '官网矩阵', path: '/website-matrix/overview' },
  { groupName: '独立站运营', code: 'product-blog', name: '产品分析', path: '/product-blog' },
  { groupName: '独立站管理', code: 'geo-optimization', name: '自然流增长（原 GEO 权限）', path: '/geo-optimization' },
  { groupName: '独立站运营', code: 'echotik-products', name: 'EchoTik商品洞察', path: '/echotik-products' },
  { groupName: '独立站运营', code: 'echotik-collection-tasks', name: 'EchoTik采集任务', path: '/echotik-collection-tasks' },
  { groupName: '独立站运营', code: 'automation-rules', name: '自动化规则配置', path: '/automation-rules' },
  { groupName: '社媒平台营销', code: 'meta-oauth', name: 'Meta授权验证', path: '/meta-oauth' },
  { groupName: '社媒平台营销', code: 'pinterest-marketing', name: 'Pinterest运营', path: '/pinterest-marketing' },
  { groupName: '社媒平台营销', code: 'facebook-marketing', name: 'Facebook运营', path: '/facebook-marketing' },
  { groupName: '客户拓展', code: 'email-center', name: '邮件中心', path: '/email-center' },
  { groupName: '客户拓展', code: 'facebook-ad-leads', name: 'Facebook广告拓客', path: '/facebook-ad-leads' },
  { groupName: '客户拓展', code: 'facebook-group-monitor', name: 'Facebook群组监控', path: '/facebook-group-monitor' },
  { groupName: '客户拓展', code: 'shop-app-hot-products', name: 'Shop平台拓展', path: '/shop-app-hot-products' },
  { groupName: '客户拓展', code: 'crm-leads', name: '拓客联系人', path: '/crm-leads' },
  { groupName: '客户拓展', code: 'customer-quotes', name: '客户报价', path: '/customer-quotes' },
  { groupName: '客户拓展', code: 'partner-development', name: '合作伙伴开发', path: '/partner-development' },
  { groupName: '客户拓展', code: 'customer-support', name: '在线客服', path: '/partner-development?tab=support' },
  { groupName: '客户拓展', code: 'logistics-rates', name: '物流费用', path: '/logistics-rates' },
  { groupName: '客户拓展', code: 'crm-lead-sourcing', name: '客户商品寻源', path: '/crm-lead-sourcing' },
  { groupName: '独立站管理', code: 'shopline-config', name: '店铺授权', path: '/shopline-config' },
  { groupName: '独立站管理', code: 'shopline-blog', name: 'Shopline博客管理', path: '/shopline-blog' },
  { groupName: '独立站管理', code: 'independent-site-competitors', name: '竞品独立站', path: '/independent-site-competitors' },
  { groupName: '独立站管理', code: 'shopline-product', name: 'Shopline商品管理', path: '/shopline-product' },
  { groupName: '独立站管理', code: 'shopline-product-listing', name: 'Shopline商品上架', path: '/shopline-product-listing' },
  { groupName: '独立站管理', code: 'shopline-theme-mapping', name: 'Shopline主题映射', path: '/shopline-theme-mapping' },
  { groupName: '独立站管理', code: 'shopline-profit-report', name: 'Shopline利润分析', path: '/shopline-profit-report' },
  { groupName: '系统配置', code: 'employee-management', name: '员工管理', path: '/employees' },
  { groupName: '系统配置', code: 'operation-logs', name: '日志中心', path: '/operation-logs' },
  { groupName: '系统配置', code: 'publish-templates', name: '发布模板', path: '/publish-templates' },
  { groupName: '系统配置', code: 'exchange-rates', name: '汇率维护', path: '/exchange-rates' },
  { groupName: '系统配置', code: 'payment-integrations', name: '支付对接配置', path: '/payment-integrations' },
  { groupName: '系统配置', code: 'shopline-account-bindings', name: '店铺账户绑定', path: '/shopline-account-bindings' },
  { groupName: '系统配置', code: 'shopline-merchants', name: '商户信息', path: '/shopline-merchants' },
  { groupName: '系统配置', code: 'ai-config', name: 'AI配置', path: '/ai-config' },
  { groupName: '系统配置', code: 'ai-task-prompts', name: 'AI场景配置', path: '/ai-task-prompts' },
  { groupName: '系统配置', code: 'oss-config', name: '阿里云OSS配置', path: '/oss-config' },
  { groupName: '系统配置', code: 'database', name: '数据库配置', path: '/database' }
]

export function routePermissionCode(path) {
  if (path.startsWith('/website-matrix')) return 'website-matrix'
  if (path.startsWith('/articles/')) return 'articles'
  if (path.startsWith('/echotik-products/')) return 'echotik-products'
  if (path.startsWith('/sales-quotes/')) return 'crm-lead-sourcing'
  if (path.startsWith('/partner-development/')) return 'partner-development'
  const normalized = path.split('?')[0]
  const match = PAGE_OPTIONS.find(item => item.path === normalized)
  return match ? match.code : ''
}

export function firstAllowedPath(user) {
  if (!user || user.role === 'admin') return '/customer-development-tasks'
  const permissions = Array.isArray(user.permissions) ? user.permissions : []
  const customerDevelopmentCodes = ['facebook-ad-leads', 'facebook-group-monitor', 'shop-app-hot-products', 'crm-leads', 'partner-development']
  if (customerDevelopmentCodes.some(code => permissions.includes(code))) return '/customer-development-tasks'
  const match = PAGE_OPTIONS.find(item => permissions.includes(item.code))
  return match ? match.path : '/login'
}

export function canAccessPage(user, code) {
  if (!code) return true
  if (!user || user.role === 'admin') return true
  const permissions = Array.isArray(user.permissions) ? user.permissions : []
  if (code === 'customer-quotes') return permissions.some(item => ['customer-quotes', 'crm-leads', 'facebook-ad-leads'].includes(item))
  return permissions.includes(code)
}
